// Customizable Area Start
import { IBlock } from "../../../framework/src/IBlock"
import { Message } from "../../../framework/src/Message"
import { BlockComponent } from "../../../framework/src/BlockComponent"
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum"
import { runEngine } from "../../../framework/src/RunEngine"
import { InfoType } from "../../../components/src/CustomInfoDialog.web"
import { facebookIcon, instagramIcon, xIcon } from "./assets"
import { logEvent } from "../../../components/src/utils/googleAnalytics/analyticsAdapter.web"
export const configJSON = require("./config")

interface ISubscribeUpdatePayload {
  subscribe: {
    email: string
  }
}

interface ISubscribeEmailSuccessResponse {
  message: string
  data: {
    id: number
    email: string
    created_at: string
    updated_at: string
  }
}

interface ISubscribeEmailErrorResponse {
  error: string
}
// Customizable Area End

export interface Props {
  // Customizable Area Start
  navigation: any
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  isLoading: boolean
  isInfoDialog: boolean
  infoType: InfoType
  infoMessage: string
  // Customizable Area End
}

interface SS {
  id: any
  // Customizable Area Start
  // Customizable Area End
}

export default class FooterController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  subscribeUpdatesApiCallId: string = ""
  socialMediaLinks = [
    {
      name: "Facebook",
      icon: facebookIcon,
      url: configJSON.FACEBOOK_PAGE_URL,
    },
    {
      name: "Instagram",
      icon: instagramIcon,
      url: configJSON.INSTAGRAM_PAGE_URL,
    },
    {
      name: "X",
      icon: xIcon,
      url: configJSON.X_PAGE_URL,
    },
  ]
  // Customizable Area End

  constructor(props: Props) {
    super(props)
    this.receive = this.receive.bind(this)

    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.RestAPIResponceMessage),
      // Customizable Area End
    ]

    this.state = {
      // Customizable Area Start
      isLoading: false,
      isInfoDialog: false,
      infoType: "success",
      infoMessage: "",
      // Customizable Area End
    }
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages)

    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  async receive(from: string, message: Message) {
    const apiRequestCallId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    )

    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    )

    if (responseJson) {
      if (apiRequestCallId === this.subscribeUpdatesApiCallId) {
        this.handleSubscribeUpdatesApiResponse(responseJson)
      }
    }
  }

  handlePageRedirection = (path: string) => {
    const navigation = new Message(getName(MessageEnum.NavigationMessage))
    navigation.addData(getName(MessageEnum.NavigationTargetMessage), path)
    navigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props)
    this.send(navigation)
  }

  handleHomeRedirect = () => {
    logEvent('footer_link_click', { link_name: 'Home' })
    this.handlePageRedirection("Home")
  }

  handleTermsNConditionRedirect = () => {
    logEvent('footer_link_click', { link_name: 'Terms & Conditions' })
    this.handlePageRedirection("TermsConditions")
  }

  handlePrivacyPolicyRedirect = () => {
    logEvent('footer_link_click', { link_name: 'Privacy Policy' })
    this.handlePageRedirection("PrivacyPolicy")
  }

  handleContactUsRedirect = () => {
    logEvent('footer_link_click', { link_name: 'Contact Us' })
    this.handlePageRedirection("Contactus")
  }

  handleSubscriptionPlansRedirect = () => {
    logEvent('footer_link_click', { link_name: 'Pricing' })
    this.handlePageRedirection("SubscriptionPlans")
  }

  handleSocialMediaIconClick = (socialMediaType: string) => {
    logEvent('footer_link_click', { link_name: socialMediaType })
  }

  openInfoDialog = (infoType: InfoType, infoMessage: string) => {
    this.setState({
      isInfoDialog: true,
      infoType,
      infoMessage,
      isLoading: false,
    })
  }

  closeInfoDialog = () => {
    this.setState({ isInfoDialog: false })
  }

  handleSubscribeUpdatesApiResponse = async (
    responseJson: ISubscribeEmailSuccessResponse | ISubscribeEmailErrorResponse
  ) => {
    if ("data" in responseJson) {
      this.openInfoDialog("success", configJSON.successSubscribeMessage)
    } else if ("error" in responseJson) {
      this.openInfoDialog("error", responseJson.error)
    } else {
      this.openInfoDialog("error", "")
    }
  }

  subscribeUpdatesApi = async (httpBody: ISubscribeUpdatePayload) => {
    const header = {
      "Content-Type": configJSON.validationApiContentType,
    }

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    )

    this.subscribeUpdatesApiCallId = requestMessage.messageId

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.subscribeUpdatesApiEndpoint
    )

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    )

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    )

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPostMethod
    )

    runEngine.sendMessage(requestMessage.id, requestMessage)
    return true
  }

  handleSubscribeUpdate = (values: { email: string }) => {
    logEvent('email_news_letter', { email: values.email })
    this.setState({ isLoading: true })
    this.subscribeUpdatesApi({ subscribe: { email: values.email } })
  }
  // Customizable Area End
}
